import React, { useState } from 'react';
import { Heading } from '../components/Heading';
import ReportsList from '../components/ReportsList';
import StoreReportMetadataList from '../components/StoreReportMetadataList';

export function Reports() {
    const title = 'Reportes de Tiendas';
    const [activeTab, setActiveTab] = useState('cargas');

    const tabs = [
        { label: 'Cargas de Tiendas', value: 'cargas' },
        { label: 'Reporte de estados', value: 'actual' },
    ];

    return (
        <>
            <Heading title={title} />

            <nav className='products'>
                <ul>
                    {tabs.map((tab) => (
                        <li
                            key={tab.value}
                            className={activeTab === tab.value ? 'selected' : ''}
                            onClick={() => setActiveTab(tab.value)}
                        >
                            {tab.label}
                        </li>
                    ))}
                </ul>
            </nav>

            <div className="container">
                {activeTab === 'cargas' && <StoreReportMetadataList />}
                {activeTab === 'actual' && <ReportsList />}
            </div>
        </>
    );
}

export default Reports;
